"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserCardAction = exports.SocketEventType = exports.SocketRoomName = void 0;
var SocketRoomName;
(function (SocketRoomName) {
    SocketRoomName["AUCTIONS"] = "auctions";
    SocketRoomName["MAIN"] = "main";
    SocketRoomName["PACKS"] = "packs";
})(SocketRoomName || (exports.SocketRoomName = SocketRoomName = {}));
var SocketEventType;
(function (SocketEventType) {
    SocketEventType["AUCTION_UPDATED"] = "auction-updated";
    SocketEventType["AUCTION_WON"] = "auction-won";
    SocketEventType["POL_RATES_UPDATED"] = "pol-rates-updated";
    SocketEventType["PACKS_STOCK_UPDATED"] = "pack-stock-updated";
    SocketEventType["USER_TOKEN_BALANCE_UPDATED"] = "user-token-balance-updated";
    SocketEventType["USER_CREDIT_BALANCE_UPDATED"] = "user-credit-balance-updated";
    SocketEventType["USER_OUTBID"] = "user-outbid";
    SocketEventType["NOTIFICATIONS_REFRESH"] = "notifications-refresh";
    SocketEventType["CANT_BID_WITH_STRIPE"] = "cant-bid-with-stripe";
    SocketEventType["USER_CARDS_UPDATED"] = "user-cards-updated";
})(SocketEventType || (exports.SocketEventType = SocketEventType = {}));
var UserCardAction;
(function (UserCardAction) {
    UserCardAction["LISTED"] = "listed";
    UserCardAction["UNLISTED"] = "unlisted";
    UserCardAction["REGISTERED_GAMEWEEK"] = "registered-gameweek";
    UserCardAction["UNREGISTERED_GAMEWEEK"] = "unregistered-gameweek";
    UserCardAction["REGISTERED_TRAINING"] = "registered-training";
    UserCardAction["UNREGISTERED_TRAINING"] = "unregistered-training";
    UserCardAction["XP_UPDATED"] = "xp-updated";
})(UserCardAction || (exports.UserCardAction = UserCardAction = {}));
